import { useState } from 'react'
import {
  aceitarPixelMonica,
  ehLinkPessoalMonica,
  lerConsentimentoPixel,
  recusarPixelMonica,
} from '@/utils/metaPixel'

interface AvisoCookiesMonicaProps {
  slug?: string | null
  pagina?: string
}

export default function AvisoCookiesMonica({ slug, pagina }: AvisoCookiesMonicaProps) {
  const [consentimento, setConsentimento] = useState(() => lerConsentimentoPixel())

  if (!ehLinkPessoalMonica(slug)) return null
  if (consentimento) return null

  const handleAceitar = () => {
    aceitarPixelMonica(slug, pagina)
    setConsentimento('aceito')
  }

  const handleRecusar = () => {
    recusarPixelMonica()
    setConsentimento('recusado')
  }

  return (
    <>
      <div className="h-36 sm:h-24" aria-hidden="true" />
      <div
        className="fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 pt-3"
        role="dialog"
        aria-label="Aviso de cookies e privacidade"
      >
        <div
          className="mx-auto max-w-3xl rounded-2xl border px-4 py-3 shadow-lg"
          style={{
            backgroundColor: '#FFFFFF',
            borderColor: '#B08968',
          }}
        >
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs sm:text-sm leading-relaxed text-[#5F5E5A] font-dm-sans">
              Usamos cookies e ferramentas de anúncio para melhorar sua experiência e medir o resultado das nossas campanhas. As respostas do seu diagnóstico não são compartilhadas com essas ferramentas.
            </p>
            <div className="flex shrink-0 items-center gap-2">
              <button
                type="button"
                onClick={handleRecusar}
                className="min-h-[40px] rounded-full border px-4 py-2 text-sm font-dm-sans font-medium transition-colors hover:bg-[#F8F4EF]"
                style={{ borderColor: '#B08968', color: '#B08968' }}
              >
                Recusar
              </button>
              <button
                type="button"
                onClick={handleAceitar}
                className="min-h-[40px] rounded-full px-4 py-2 text-sm font-dm-sans font-medium text-white transition-opacity hover:opacity-90"
                style={{ backgroundColor: '#2D6A4F' }}
              >
                Aceitar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
